import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Currency } from 'components'
import messages from 'i18n/messages'
import classNames from 'classnames'
import { useSelector, useDispatch } from 'react-redux'
import { makeSelectItemQty, setItemQty } from 'logic/goods'

export default function GoodsPage ({ product }) {

  const dispatch = useDispatch()
  const qty = useSelector(makeSelectItemQty(() => product.id))
  const handleIncQty = () => qty < 10 && dispatch(setItemQty(product.id, qty + 1))
  const handleDecQty = () => qty > 0 && dispatch(setItemQty(product.id, qty - 1))
  
  return (
    <div className={classNames('qty-form-control-price-options open', { 'has-items-in-basket': qty > 0 })}>
      <div className="price-item">
        <div className="price-name">
          <div>{product.name}</div>
          <div className="price-desc" dangerouslySetInnerHTML={{ __html: product.description }} />
        </div>
        <div className="price-value">
          <div className="font-weight-bold"><Currency value={product.total} /></div>
          <small>{product.unit ? `${product.unit}` : <FormattedMessage {...messages.piece} />}</small>
        </div>
        <div className="qty-switches">
          <div className={classNames('qty-btn', { disabled: qty < 1 })} onClick={handleDecQty}>
            <span className="tt-icon tt-icon-i-delete" />
          </div>
          <div className="qty-value">
            {qty}
          </div>
          <div className={classNames('qty-btn', { disabled: qty > 9 })} onClick={handleIncQty}>
            <span className="tt-icon tt-icon-i-add" />
          </div>
        </div>
      </div>
    </div>
  )
}